var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { styled } from 'styled-components';
import { useScreenName } from '../../landing/components/hooks';
import { cards } from './data';
import { Slider } from './Slider/Slider';
var ScSlider = styled(Slider).withConfig({ displayName: "ScSlider", componentId: "sc-1w90h4s" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 40px;\n\n  ", " {\n    margin-bottom: 30px;\n  }\n"], ["\n  margin-bottom: 40px;\n\n  ", " {\n    margin-bottom: 30px;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
});
var cardWidth = 306;
var cardRightMargin = 16;
var SocialFeedbacksSlider = function () {
    var screenName = useScreenName();
    var _a = useMemo(function () {
        if (screenName === 'tablet')
            return { cardCount: 2, maxWidth: 2 * (cardWidth + cardRightMargin) };
        if (screenName === 'mobile')
            return { cardCount: 1, maxWidth: 1 * (cardWidth + cardRightMargin) };
        return { cardCount: 3, maxWidth: 3 * (cardWidth + cardRightMargin) };
    }, [screenName]), cardCount = _a.cardCount, maxWidth = _a.maxWidth;
    // TODO: remove the next line after redesign
    var _cards = screenName === 'mobile' ? cards.slice(0, 8) : cards;
    return (_jsx(ScSlider, { cards: _cards, cardsPerPage: cardCount, maxWidth: maxWidth }, void 0));
};
export { SocialFeedbacksSlider };
var templateObject_1;
